import Axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import api from '../../api';
import { generateRequestHeaders } from '../../utils';
import DevLogger from '../../components/_dev-logger';

let flag = false

const Api = () => {
  const { pathname, search } = useLocation()
  const finalPath = pathname.split('/_api/')[1]
  const endpoint = finalPath+search
  const [data, setData] = useState(null)
  const [error, setError] = useState(null)

  useEffect(() => {
    if(flag === false){
      flag = true
      Axios.get(api.base+endpoint, {headers: generateRequestHeaders()})
        .then(res => {
          if(res.data){
            setData(res.data)
          } else {
            setData(res)
          }
        })
        .catch(err => {
          setError(err)
        })
    }
  }, [endpoint])

  return <div className="p-4">
    <h3>Endpoint: {endpoint}</h3>

    <h3>Response:</h3>
    <div className="overflow-y-auto" style={{maxHeight: '50vh'}}>
      <DevLogger data={{data}}/>
    </div>

    <h3>Error:</h3>
    <DevLogger data={{error}}/>
  </div>
}

export default Api
